//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ssdh',
  data() {
    return {
      form: {
        sex: '',
        item1: '',
        item2: '',
      },
      sexList: [
        { value: '0', name: '男' },
        { value: '1', name: '女' },
      ],
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          console.log(form, 'form');
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result
        if (form.sex == 0) {
          result = (142 - form.item1) * form.item2 * 0.6
        } else {
          result = (142 - form.item1) * form.item2 * 0.5
        }
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/ssdh.vue